import { Button, InputCurrency } from "@sellar-io/components";
import { DeliveryChargeFulfillmentType } from "@sellar-io/api-v2/types";
import { useId } from "react";
import { useForm } from "react-hook-form";
import { Alert } from "../../../../components/alert/Alert";
import { InputLabel, InputContainer } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useFulfillmentTypeCreate } from "../../../../hooks/api/v2/fulfillmentType/useFulfillmentTypeCreate";
import { useFulfillmentTypeUpdate } from "../../../../hooks/api/v2/fulfillmentType/useFulfillmentTypeUpdate";

export const FulfillmentTypeUpdateDialog = ({
  active,
  onDismiss,
  charge,
  fulfillmentTypeId,
  fulfillmentType,
}: {
  active: boolean;
  onDismiss: () => void;
  charge?: number | null;
  fulfillmentType: DeliveryChargeFulfillmentType;
  fulfillmentTypeId?: number;
}) => {
  const form = useForm<{ charge: number }>({
    shouldUseNativeValidation: true,
    defaultValues: {
      charge: charge ? charge / 100 : 0,
    },
  });
  const formId = useId();

  const fulfillmentTypeCreateMutation = useFulfillmentTypeCreate();
  const fulfillmentTypeUpdateMutation = useFulfillmentTypeUpdate(
    fulfillmentTypeId ?? 0,
  );

  const onSubmit = (data: { charge: number }) => {
    if (!fulfillmentTypeId) {
      return fulfillmentTypeCreateMutation.mutate(
        {
          charge: parseFloat(data.charge.toString()) * 100,
          fulfillmentType,
        },
        {
          onSuccess: () => onDismiss(),
        },
      );
    }
    fulfillmentTypeUpdateMutation.mutate(
      {
        charge: parseFloat(data.charge.toString()) * 100,
      },
      {
        onSuccess: () => onDismiss(),
      },
    );
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={`${fulfillmentTypeId ? "Update" : "Add"} flat delivery free`}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogContent>
        {fulfillmentTypeUpdateMutation.isError ||
        fulfillmentTypeCreateMutation.isError ? (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(
                fulfillmentTypeUpdateMutation.error ??
                  fulfillmentTypeCreateMutation.error,
              )?.response?.data.message ?? "Unknown error occurred."
            }
          />
        ) : null}
        <form
          id={formId}
          onSubmit={form.handleSubmit(onSubmit)}
          className={"flex flex-col gap-2"}
        >
          <InputLabel>Amount</InputLabel>
          <InputContainer>
            <InputCurrency
              showPrefix
              allowNegative
              {...form.register("charge", {
                required: true,
                valueAsNumber: true,
              })}
            />
          </InputContainer>
        </form>
      </DialogContent>
      <DialogCTA>
        <Button
          type="submit"
          form={formId}
          loading={
            fulfillmentTypeUpdateMutation.isPending ||
            fulfillmentTypeCreateMutation.isPending
          }
        >
          Update
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
